import { getWowPricingVariant, isWowPricingEnabled } from '@/utils/wowPricing'

/**
 * WOW experiment state. WOW is at 100%, so there is no Statsig read and no
 */
export function useWowPricingState() {
    const wowPricingVariant = getWowPricingVariant()
    const wowOn = isWowPricingEnabled(wowPricingVariant)

    return { rawVariant: wowPricingVariant, wowPricingVariant, wowOn }
}
